// eslint-disable-next-line max-classes-per-file
export interface RequestContactListInfoInterface {
  account_id: string;
}

export class ContactDetail {
  id: string;

  account_id: string;

  contact_name: string;

  country_id: number;

  country_of_passport: number;

  city_id: number;

  titlename: string;

  firstname: string;

  lastname: string;

  address_1: string;

  address_2: string;

  postcode: string;

  prefix_phone: string;

  phone_number: string;

  is_deleted: number;

  status: number;

  created_at: string;

  updated_at: string;

  email: string;

  sort: number;

  primary_contact: number;

  passport_number: string;

  passport_expiry_date?: string;

  birthday: string;

  country_of_issued_passport: number;

  constructor(data: any) {
    const prefix: string = data?.prefix_phone?.replace("+", "") ?? "";
    const phone: string = data?.phone_number?.replace("+", "") ?? "";
    this.id = data?.id || "";
    this.account_id = data?.account_id || "";
    this.contact_name = data?.contact_name || "";
    this.country_id = data?.country_id || 0;
    this.country_of_passport = data?.country_of_passport || 0;
    this.city_id = data?.city_id || 0;
    this.titlename = data?.titlename || "";
    this.firstname = data?.firstname || "";
    this.lastname = data?.lastname || "";
    this.address_1 = data?.address_1 || "";
    this.address_2 = data?.address_2 || "";
    this.postcode = data?.postcode || "";
    this.prefix_phone = prefix || "";
    this.phone_number = phone || "";
    this.is_deleted = data?.is_deleted || 0;
    this.status = data?.status || 0;
    this.created_at = data?.status || "";
    this.updated_at = data?.updated_at || "";
    this.email = data?.email || "";
    this.sort = data?.sort || 0;
    this.primary_contact = data?.primary_contact || 0;
    this.passport_number = data?.passport_number || "";
    this.passport_expiry_date = data?.passport_expiry_date || "";
    this.birthday = data?.birthday || "";
    this.country_of_issued_passport = data?.country_of_issued_passport || 0;
  }
}

export class ResponseContactListInfoInterface {
  status: boolean;

  data: ContactDetail[];

  constructor(data: any) {
    this.status = data?.status || false;
    this.data = data?.data?.map((res: any) => new ContactDetail(res)) || [];
  }
}
